<template>
    <div>
        <v-container fluid class="py-0 grey lighten-2">
            <v-row>
                <v-card flat color="transparent" class="mx-auto py-6 text-center">
                    <v-card-title class="display-1 mb-2">{{ $t("about.about") }}</v-card-title>
                    <v-card-subtitle class="subtitle-1">ABOUT US</v-card-subtitle>
                </v-card>
            </v-row>
            <v-row no-gutters class="text-center" align="start">
                <v-spacer class="d-none d-sm-flex"></v-spacer>
                <v-col>
                    <v-card class="mb-4" flat tile color="transparent">
                        <v-card-title :class='isMobile?"subtitle-1":"title font-weight-regular text-no-wrap justify-center"' v-html="$t('about.content')">{{ $t('about.content') }}</v-card-title>
                    </v-card>
                </v-col>
                <v-spacer class="d-none d-sm-flex"></v-spacer>
            </v-row>
            <v-row>
                <tci-pic-div
                        :title="$t('overview.title')"
                        subtitle="OVERVIEW"
                        jumpTo="/company-overview"
                        :imgSrc="require('../assets/2-1.jpg')"
                ></tci-pic-div>
                <tci-pic-div
                        :title="$t('corporate_vision.title')"
                        subtitle="CORPORATE VISION"
                        jumpTo="/company-vision"
                        :imgSrc="require('../assets/2-2.jpg')"
                ></tci-pic-div>
            </v-row>
            <v-row>
                <tci-pic-div
                        :title="$t('history.title')"
                        subtitle="HISTORY"
                        jumpTo="/company-history"
                        :imgSrc="require('../assets/2-3.jpg')"
                ></tci-pic-div>
                <tci-pic-div
                        :title="$t('organization.title')"
                        subtitle="ORGANIZATION"
                        jumpTo="/company-organization"
                        :imgSrc="require('../assets/2-4.jpg')"
                ></tci-pic-div>
            </v-row>
            <v-row>
                <tci-pic-div
                        :title="$t('about.interview')"
                        subtitle="INTERVIEW"
                        jumpTo="/blank-3"
                        :imgSrc="require('../assets/company/c5.jpg')"
                ></tci-pic-div>
                <tci-pic-div
                        :title="$t('about.award')"
                        subtitle="AWARD"
                        jumpTo="/company-award"
                        :imgSrc="require('../assets/company/c6.jpg')"
                        imgStyle="filter: brightness(80%);"
                ></tci-pic-div>
            </v-row>
        </v-container>
        <tci-contact-footer color="white"></tci-contact-footer>
    </div>
</template>

<script>
    import TciContactFooter from "@/components/TciContactFooter.vue";
    import TciPicDiv from "@/components/TciPicDiv.vue";

    export default {
        name: "CompanyAboutUs",
        components: {
            "tci-contact-footer": TciContactFooter,
            "tci-pic-div": TciPicDiv
        },
        data: () => ({
        recruits: [
            {"imageUrl":require('../assets/recruit/2-1.jpg'),"title":"项目开发负责人","to":"/recruit-project-manager"},
            {"imageUrl":require('../assets/recruit/2-2.jpg'),"title":".NET开发工程师","to":"/recruit-bdeveloper"},
            {"imageUrl":require('../assets/recruit/2-3.jpg'),"title":"C++项目开发负责人","to":"/recruit-translate"},
            {"imageUrl":require('../assets/recruit/2-4.jpg'),"title":"图像及视觉算法工程师","to":"/recruit-bserver-engineer"}
        ],
        isMobile: false
    }),
    methods:{

    },
    mounted() {
        this.isMobile = this.$vuetify.breakpoint.xs;
    }
    };
</script>
